
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );

        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector("cart-drawer");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute("aria-disabled") === "true"
        ) return;

        this.handleErrorMessage();

        const qtyInput = this.form.querySelector(
          'input[name="quantity"]'
        );

        if (qtyInput) {
          const max = parseInt(qtyInput.getAttribute("max"), 10);
          const min =
            parseInt(qtyInput.getAttribute("min"), 10) || 1;

          let val = parseInt(qtyInput.value, 10);

          if (isNaN(val) || val < min) val = min;
          else if (!isNaN(max) && val > max) val = max;

          qtyInput.value = val;
        }

        const formData = new FormData(this.form);

        const jewelryVariantId = Number(formData.get("id"));
        const quantity = Number(formData.get("quantity") || 1);

        const bouquetCheckbox = document.querySelector(
          "#ar-bouquet-checkbox"
        );

        const wantsBouquet =
          bouquetCheckbox &&
          bouquetCheckbox.checked &&
          !bouquetCheckbox.disabled;

        const personalizationVariantId = 59262828478799;

        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let requestBody = formData;

        if (wantsBouquet) {
          const linkedId =
            "ar-bouquet-" +
            Date.now() +
            "-" +
            Math.random().toString(36).slice(2, 10);

          const jewelryProperties = {};

          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);

            if (match) {
              jewelryProperties[match[1]] = value;
            }
          }

          jewelryProperties["_Personalizacija"] =
            "Latice vjenčanog buketa";

          jewelryProperties["_BouquetLink"] = linkedId;

          const payload = new FormData();

          const items = [
            {
              id: jewelryVariantId,
              quantity,
              properties: jewelryProperties
            },
            {
              id: personalizationVariantId,
              quantity,
              properties: {
                "_BouquetLink": linkedId,
                "_PovezaniNakit": String(jewelryVariantId)
              }
            }
          ];

          items.forEach((item, index) => {
            payload.append(
              `items[${index}][id]`,
              String(item.id)
            );

            payload.append(
              `items[${index}][quantity]`,
              String(item.quantity)
            );

            Object.entries(item.properties).forEach(
              ([key, value]) => {
                payload.append(
                  `items[${index}][properties][${key}]`,
                  value
                );
              }
            );
          });

          requestBody = payload;
        }

        const sectionIds = this.cart
          ? this.cart.getSectionsToRender().map(
              (section) => section.id
            )
          : [];

        if (this.cart) {
          requestBody.append(
            "sections",
            sectionIds.join(",")
          );

          requestBody.append(
            "sections_url",
            window.location.pathname
          );
        }

        config.body = requestBody;

        this.submitButton.setAttribute(
          "aria-disabled",
          "true"
        );

        this.submitButton.classList.add("loading");

        this.querySelector(".spinner-loading-btn")
          ?.classList.remove("hidden");

        this.submitButton
          .querySelector("[data-addtocart-text]")
          ?.classList.add("hidden");

        try {
          const response = await fetch(
            routes.cart_add_url,
            config
          );

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
              result.message ||
              "Proizvod nije moguće dodati u košaricu."
            );
          }

          this.error = false;

          if (!this.cart) {
            window.location.href = window.routes.cart_url;
            return;
          }

          const sticky = document.querySelector(
            ".product-cart-sticky"
          );

          if (sticky) {
            sticky.classList.remove("active");

            sticky.querySelector(
              ".product-cart-sticky-detail"
            )?.classList.remove("active");
          }

          /*
           * Nakon dodavanja osvježavamo sekcije košarice.
           * Tako ne ovisimo o strukturi odgovora za
           * pojedinačni proizvod ili više proizvoda.
           */

          const sectionsResponse = await fetch(
            `${routes.cart_url}?sections=${sectionIds.join(",")}`
          );

          if (!sectionsResponse.ok) {
            throw new Error(
              "Košarica je ažurirana, ali prikaz nije osvježen."
            );
          }

          const sections = await sectionsResponse.json();

          this.cart.renderContents({
            sections: sections
          });

          this.cart.classList.add("open");

          document.body.classList.add("no-scroll");

          const cartResponse = await fetch(
            window.routes.cart_url + ".js"
          );

          if (cartResponse.ok) {
            const cartData = await cartResponse.json();

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: String(jewelryVariantId),
              cartState: cartData
            });
          }

        } catch (error) {
          console.error(
            "A.Rechine cart error:",
            error
          );

          this.error = true;

          this.handleErrorMessage(
            error.message ||
            "Dogodila se pogreška. Pokušajte ponovno."
          );

        } finally {
          this.resetButton();
        }
      }

      resetButton() {
        if (!this.submitButton) return;

        this.submitButton.classList.remove("loading");

        this.submitButton
          .querySelector("[data-addtocart-text]")
          ?.classList.remove("hidden");

        if (
          this.cart &&
          this.cart.classList.contains("is-empty")
        ) {
          this.cart.classList.remove("is-empty");
        }

        this.submitButton.removeAttribute(
          "aria-disabled"
        );

        this.querySelector(".spinner-loading-btn")
          ?.classList.add("hidden");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper"
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
